export const SET_PROGRAM_LOGOS = 'SET_PROGRAM_LOGOS';
export const SET_DEALER_CODE = 'SET_DEALER_CODE';
export const SET_LOGO_INFO_DATA = 'SET_LOGO_INFO_DATA';
